import LogService from '@/api/broadcast/LogService'
import UserManagementService from '@/api/user/UserManagementService'
import store from '@/store/store'

const downloadAppFunc = {
  async checkOS () {
    try {
      // Fire metric about DownloadApp clicked for use in Zest Conversion board.
      if (store.getHotelInfo()) {
        const bookingInfo = store.getHotelInfo()
        await UserManagementService.DownloadAppPressed(bookingInfo.BookingId, bookingInfo.HotelId, bookingInfo.StartDate, bookingInfo.EntryType)
        LogService.LogInformation('Join, DownloadAppPage, Fire DownloadAppMetric', { DownloadAppSuccess: 1 })
      }
    } catch (error) {
      LogService.LogError('Join, DownloadAppPage, Fire DownloadAppMetric failed', { DownloadAppFailed: 1 })
      // TODO-OOP: Visual error-handling feedback
    }
    const language = window.navigator.language
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
      window.location.href = 'https://play.google.com/store/apps/details?id=ag.app.android'
      LogService.LogInformation('Join, DownloadAppPage, Redirect to Android store', { RedirectAndroidStoreSuccess: 1 })
    } else if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
      window.location.href = `https://apps.apple.com/dk/app/aeroguest/id1164025815?l=${language || 'en'}`
      LogService.LogInformation('Join, DownloadAppPage, Redirect to iOS App store', { RedirectAppStoreSuccess: 1 })
    } else {
      window.location.href = 'https://aeroguest.com/'
      LogService.LogInformation('Join, DownloadAppPage, Redirect to aeroguest homepage', { RedirectAeroguestSuccess: 1 })
    }
  },
  checkIfDesktop () {
    return !(navigator.userAgent.toLowerCase().indexOf('android') > -1) && !(navigator.userAgent.toLowerCase().indexOf('iphone') > -1)
  }
}

export default downloadAppFunc
